module.exports = __webpack_public_path__ + "static/img/qrcode.9f43b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode.jpg
// module id = Hjk3
// module chunks = 28